import { useId } from 'react';
import './pin-security.css';

export default function PinDigits({ label, value, onChange, disabled, autoFocus = false, continuous = false }) {
    const id = useId();
    return <div className="pin-field">
        <label htmlFor={id}>{label}</label>
        <div className={`pin-digits ${continuous ? 'pin-digits-continuous' : ''} ${value.length === 4 ? 'is-filled' : ''}`}>
            <input id={id} type="password" inputMode="numeric" autoComplete="off" maxLength={4}
                autoFocus={autoFocus} value={value} disabled={disabled}
                onChange={e => onChange(e.target.value.replace(/[^0-9]/g, '').slice(0, 4))} />
            <div className="pin-digit-slots" aria-hidden="true">
                {[0, 1, 2, 3].map(i => <span key={i} className={value.length === i ? 'is-next' : ''}>{value[i] ? '●' : ''}</span>)}
            </div>
        </div>
    </div>;
}
